import Header from "./components/Header";
import Hero from "./components/Hero";
import TopicWall from "./components/TopicWall";
import TopLines from "./components/TopLines";
import ScenarioPicks from "./components/ScenarioPicks";
import CompareBoard from "./components/CompareBoard";
import SpeedTest from "./components/SpeedTest";
import QuickGuide from "./components/QuickGuide";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicWall />
        <TopLines />
        <ScenarioPicks />
        <CompareBoard />
        <SpeedTest />
        <QuickGuide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}